import gql from 'graphql-tag';

export const MEMBER_SEARCH_QUICK_FILTERS_COUNTS_QUERY = gql`
  query MemberCountForQuickFilters($query: JSONObject!) {
    counts: memberCountForQuickFilters(query: $query)
  }
`;
